import { all } from 'redux-saga/effects'
import { updateSaga } from './update/saga'

export function* passwordSaga() {
  yield all([updateSaga()])
}
